import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { ColumnGroup } from 'react-table';

import { Zone } from 'types';

import { usersDataService } from 'services/users.service';

import { routes } from 'data/routes';

import { EditForm } from 'sections/EditForm';
import { SectionType, TabWrap } from 'sections/TabWrap';

import { Actions } from 'components/Actions';
import { TabType } from 'components/Tabs';

import { zonesFormData } from './constants';

export const useZones = () => {
  const [zones, setZones] = useState<Zone[]>([]);
  const navigate = useNavigate();
  const params = Object.values(useParams())[0] as string;

  const {
    register,
    control,
    handleSubmit,
    formState: { isDirty, isValid, isSubmitting },
  } = useForm();

  const addNewZone = async (data: any) => {
    const formattedData = {
      ...data,
      type: JSON.parse(data.type),
    };
    await usersDataService.addZone(formattedData);
    toast.success('Zone added successfully!');
    navigate(routes.zones);
  };

  const editZone = async (data: any) => {
    console.log('editZone', data);
  };

  const zoneSubmit = async (data: any) => {
    try {
      if (params === 'new') {
        addNewZone(data);
        return;
      }
      editZone(data);
    } catch (error) {
      toast.error('Error adding season');
      console.error(error);
    }
  };

  const zonesSections: SectionType[] = [
    {
      id: 1,
      content: (
        <EditForm
          data={zonesFormData}
          register={register}
          onSubmit={handleSubmit(zoneSubmit)}
          submitBtnLabel="Submit"
          control={control}
          hideUndo
          hasButtons
          isDirty={isDirty}
          isButtonsDisabled={!isValid || isSubmitting}
        />
      ),
    },
  ];

  const zonesForm = <TabWrap sections={zonesSections} />;

  const zonesTab: TabType[] = [
    {
      id: 1,
      title: 'Data',
      content: zonesForm,
    },
  ];

  const zonesColumns: ColumnGroup[] = [
    {
      Header: 'Zones',
      columns: [
        {
          Header: 'Description',
          accessor: 'desc',
        },
        {
          Header: 'Location',
          accessor: 'location',
        },
        {
          Header: 'Code',
          accessor: 'code',
        },
        {
          accessor: 'actions',
          disableSortBy: true,
          Cell: () => <Actions isEditPath hasDelete tableName="zones" toTheRight />,
        },
      ],
    },
  ];

  const getZones = async () => {
    try {
      const res = await usersDataService.getZones();
      const formattedZones = res.data.map((zone: any) => ({
        ...zone,
        actions: ['edit', 'delete'],
      }));
      setZones(formattedZones.sort((a: any, b: any) => a.code - b.code));
      console.log(formattedZones);
    } catch (error) {
      console.error('getSeasons error', error);
    }
  };

  useEffect(() => {
    getZones();
  }, []);

  return {
    zonesTab,
    zones,
    zonesColumns,
  };
};
